const LOSE_PIECE = 10;
const NORMAL_PIECE = 11;
const GameConfig = {
    // Control configuration
    rotateSpeed: Math.PI * 0.008,
    keyRotateSpeed: 2,
    shieldKeyCode: 67, //"f"
    arrowKeyCode: 66, //"c"
    happyTimeShowed: false,
    startedBestScore: 0,

    // Light configuration
    ambientLightColor: "#999999",
    ambientLightIntensity: 0.8,
    directLightLightColor: "#ffffff",
    directLightIntensity: .6,
    pointLightLightColor: "#ffffff",
    pointLightIntensity: 1.2,
    pointLightDistance: 20,

    // Configuration of the camera position
    cameraX: 0,
    cameraY: 7,
    cameraZ: -11,
    lookAtY: -5,
    cameraFov: 67,
    cameraZoom: 1.2,

    // Configuration of the ball
    // Initial scale of the ball
    initialXScale: 0.6,
    initialYScale: 0.6,

    // Position of the ball bounce up high
    bounceYPos: 2.4,


    // Duration of a circle moving up and down Limit
    movementCircleDurationLimit: 0.17,

    // Duration of a circle moving up and down
    initMovementCircleDuration: 0.38,
    movementCircleDuration: 0.38,

    //  moving up and down accumulation value
    movementCircleDurationAccCoef: 0.00002,

    // Gravitational acceleration limit
    gravitationalAccelerationLimit: 50,

    // Gravitational accelerationc accumulation value
    initGravitationalAcceleration: 8,
    gravitationalAcceleration: 8,

    // Gravitational acceleration accumulation coef
    gravitationalAccelerationAccCoef: 1.0002,


    // Initial velocity when going down
    initialVelocity: 10,

    // Time to obtain the maximum velocity
    timeForMaxVelocity: 2,//5,

    // Time duration of the Shield (sec)
    timeForShield: 10,

    // Old skin list
    oldSkinNameList: ["Angle", "BigBall", "Dad", "Devil", "Mask", "Spike", "Torus"],

    // Skin shop skin list
    basicSkinList: [
        { name: "Barrel", scale: 0.5 },
        { name: "Basketball", scale: 0.3 },
        { name: "Beachball", scale: 0.17 },
        { name: "ChickenBucket", scale: 0.2 },
        { name: "DinoEgg", scale: 0.2 },
        { name: "HumanEye", scale: 0.3 },
        { name: "Football", scale: 0.3 },
        { name: "LegoHead", scale: 0.25 },
        { name: "Shield", scale: 0.4 },
    ],
    rareSkinList: [
        { name: "Baseball", scale: 0.3 },
        { name: "Cube", scale: 0.25 },
        { name: "Gyroscope", scale: 0.15 },
        { name: "Mandalorian", scale: 0.3 },
        { name: "Minion", scale: 0.3 },
        { name: "Mushroom", scale: 0.3 },
        { name: "Powerball", scale: 0.18 },
        { name: "Smiley", scale: 0.25 },
        { name: "Planet", scale: 0.17 },
    ],
    funkySkinList: [
        { name: "Apple", scale: 0.2 },
        { name: "Bottle", scale: 0.5 },
        { name: "Chest", scale: 0.25 },
        { name: "RubberDuck", scale: 0.12 },
        { name: "Fish", scale: 0.14 },
        { name: "Gem", scale: 0.3 },
        { name: "Pacman", scale: 0.3 },
        { name: "Pokeball", scale: 0.3 },
        { name: "Pumpkin", scale: 0.35 },
    ],
    epicSkinList: [
        { name: "SprinkleBall", scale: 0.26 },
        { name: "Frame", scale: 0.17 },
        { name: "MoonMeteor", scale: 0.15 },
        { name: "Gear", scale: 0.3 },
        { name: "Fog", scale: 0.3 },
        { name: "Rainbow", scale: 0.27 },
        { name: "Skull", scale: 0.28 },
        { name: "Spiral", scale: 0.15 },
        { name: "Star", scale: 0.15 },
    ],
    chestSkinList: [
        { name: "Bone", scale: 0.2 },
        { name: "Dice", scale: 0.4 },
        { name: "Heart", scale: 1 },
        { name: "Steve", scale: 0.25 },
        { name: "Shoe", scale: 0.11 },
        { name: "Teddy", scale: 0.2 },
        { name: "Tennisball", scale: 0.25 },
        { name: "Volleyball", scale: 0.25 },
        { name: "Wheel", scale: 0.17 },
    ],

    // With total 28 piece max, the platform will split with min to max chunk
    chunkSplitMin: 6,
    chunkSplitMax: 12,

    // Type of the platform generated
    losePiece: LOSE_PIECE,
    normalPiece: NORMAL_PIECE,
    platformPieceType: [
        { type: LOSE_PIECE },
        { type: NORMAL_PIECE },
    ],

    // Distance between each platform
    platformOffset: 4,

    // Platform "y" scale
    platformYScale: 1.4,

    //last platforms to loop
    loopIndexLimitId: 2,

    // The construction of the level
    levelGenerator: [
        { level: 0, count: 5 },
        { level: 1, count: 6 },
        { level: 2, count: 2 },
        { level: 1, count: 8 },
        { level: 2, count: 9 },
        { level: 3, count: 2 },
        { level: 1, count: 5 },
        { level: 2, count: 6 },
        { level: 0, count: 8 },
        { level: 3, count: 3 },
        { level: 1, count: 4 },
        { level: 2, count: 8 },
        { level: 1, count: 2 },
        { level: 3, count: 4 },
        { level: 1, count: 2 },
        { level: 2, count: 10 },
        { level: 1, count: 2 },
        { level: 3, count: 12 },
        { level: 0, count: 8 },
        { level: 2, count: 8 },
        { level: 3, count: 20 }
    ],





    gameColors: [
        {
            losePlatformColor: "#EC4428",
            losePlatformSpecularColor: "#FF6D6D",
            normalPlatformColor: '#313131',
            normalPlatformSpecularColor: '#989898',
            tubeColor: '#E7E7E7',
            tubeSpecularColor: '#FFFFFF',
            ballColorNormal: "#ECBE28",
            ballSpecularColorNormal: "#FFC46D",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#FFFFFF, #2D2D2D)',
        },
        {
            losePlatformColor: "#EC6D28",
            losePlatformSpecularColor: "#FFAC6D",
            normalPlatformColor: '#596392',
            normalPlatformSpecularColor: '#92FAFF',
            tubeColor: '#D4D29F',
            tubeSpecularColor: '#FAFFCA',
            ballColorNormal: "#3BB6DF",
            ballSpecularColorNormal: "#81D2EC",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#FFF0BF, #4F34A5)',
        },
        {
            losePlatformColor: "#FF6C1A",
            losePlatformSpecularColor: "#FF6335",
            normalPlatformColor: '#FFDE57',
            normalPlatformSpecularColor: '#FDFF9D',
            tubeColor: '#FCED97',
            tubeSpecularColor: '#FFF8D1',
            ballColorNormal: "#BFCD40",
            ballSpecularColorNormal: "#DCEC2D",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#F8FFBC, #97A92B)',
        },
        {
            losePlatformColor: "#D83C60",
            losePlatformSpecularColor: "#FF358D",
            normalPlatformColor: '#893D6B',
            normalPlatformSpecularColor: '#853F52',
            tubeColor: '#DF8A78',
            tubeSpecularColor: '#FFBDAC',
            ballColorNormal: "#FF583D",
            ballSpecularColorNormal: "#FF8948",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#FFBA94, #267070)',
        },
        {
            losePlatformColor: "#FBD91A",
            losePlatformSpecularColor: "#FFD54B",
            normalPlatformColor: '#8AC10B',
            normalPlatformSpecularColor: '#B2FF94',
            tubeColor: '#A8E5CC',
            tubeSpecularColor: '#CEFFE7',
            ballColorNormal: "#6955D6",
            ballSpecularColorNormal: "#868CFD",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#F6A5FF, #178779)',
        },
        {
            losePlatformColor: "#F6583D",
            losePlatformSpecularColor: "#FD6565",
            normalPlatformColor: '#453F3D',
            normalPlatformSpecularColor: '#706363',
            tubeColor: '#D28449',
            tubeSpecularColor: '#FFE692',
            ballColorNormal: "#D0DADD",
            ballSpecularColorNormal: "#FFFFFF",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#E0E188, #4E988C)',
        },
        {
            losePlatformColor: "#FB92C0",
            losePlatformSpecularColor: "#FFC5DE",
            normalPlatformColor: '#4BBEF8',
            normalPlatformSpecularColor: '#74D8E1',
            tubeColor: '#CFE9FB',
            tubeSpecularColor: '#DAF3FF',
            ballColorNormal: "#1F2772",
            ballSpecularColorNormal: "#33518B",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#F8D6FF, #422F8E)',
        },
        {
            losePlatformColor: "#F05E00",
            losePlatformSpecularColor: "#FF9E60",
            normalPlatformColor: '#FFBA26',
            normalPlatformSpecularColor: '#FFEF70',
            tubeColor: '#FBF3CF',
            tubeSpecularColor: '#FDFFDA',
            ballColorNormal: "#1F2122",
            ballSpecularColorNormal: "#303335",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#FFF287, #AC5F42)',
        },
        {
            losePlatformColor: "#F96B1D",
            losePlatformSpecularColor: "#FD9A65",
            normalPlatformColor: '#FFE4B4',
            normalPlatformSpecularColor: '#FFF7CC',
            tubeColor: '#40295C',
            tubeSpecularColor: '#523C81',
            ballColorNormal: "#CB94F6",
            ballSpecularColorNormal: "#C596FF",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#201751, #FBBC83)',
        },
        {
            losePlatformColor: "#BC8EFF",
            losePlatformSpecularColor: "#FF8FF3",
            normalPlatformColor: '#A7E5F9',
            normalPlatformSpecularColor: '#FFFBF2',
            tubeColor: '#FBF3CF',
            tubeSpecularColor: '#FDFFDA',
            ballColorNormal: "#383838",
            ballSpecularColorNormal: "#C515151",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#FFF0BF, #C6F5F9)',
        },
        {
            losePlatformColor: "#6CCBF2",
            losePlatformSpecularColor: "#6CCBF2",
            normalPlatformColor: '#493A78',
            normalPlatformSpecularColor: '#FFFBF2',
            tubeColor: '#7961C5',
            tubeSpecularColor: '#AA96EA',
            ballColorNormal: "#D4E7F2",
            ballSpecularColorNormal: "#FFFFFF",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#C7BFFF, #FDEBC5)',
        },
        {
            losePlatformColor: "#F27A6C",
            losePlatformSpecularColor: "#F27A6C",
            normalPlatformColor: '#FFFFFF',
            normalPlatformSpecularColor: '#FFFBF2',
            tubeColor: '#F2D68D',
            tubeSpecularColor: '#FFEAB4',
            ballColorNormal: "#51A8DB",
            ballSpecularColorNormal: "#75BFEA",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#6C2A76, #78B0DF)',
        },
    ],

    gameColorsAsmr: [
        {
            losePlatformColor: "#B02A2A",
            losePlatformSpecularColor: "#E75D5D",
            normalPlatformColor: '#FFDC40',
            normalPlatformSpecularColor: '#F19D35',
            tubeColor: '#F5F2F2',
            tubeSpecularColor: '#F8F8F8',
            ballColorNormal: "#00ABFF",
            ballSpecularColorNormal: "#66E2FF",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#A4CAE0, #ED98F3)',
        },
        {
            losePlatformColor: "#B02A2A",
            losePlatformSpecularColor: "#E75D5D",
            normalPlatformColor: '#F85651',
            normalPlatformSpecularColor: '#FF9C96',
            tubeColor: '#FFFFFF',
            tubeSpecularColor: '#FFFFFF',
            ballColorNormal: "#FF753D",
            ballSpecularColorNormal: "#FFAFAC",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#FFF0BF, #4F34A5)',
        },
        {
            losePlatformColor: "#B02A2A",
            losePlatformSpecularColor: "#E75D5D",
            normalPlatformColor: '#FFAC40',
            normalPlatformSpecularColor: '#F8B25C',
            tubeColor: '#FFFFFF',
            tubeSpecularColor: '#FFFFFF',
            ballColorNormal: "#26D5F3",
            ballSpecularColorNormal: "#66E2FF",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#FFFFFF, #4DD9D9)',
        },
        {
            losePlatformColor: "#B02A2A",
            losePlatformSpecularColor: "#E75D5D",
            normalPlatformColor: '#5CA7FF',
            normalPlatformSpecularColor: '#7D5FFF',
            tubeColor: '#FFFFFF',
            tubeSpecularColor: '#FFFFFF',
            ballColorNormal: "#FFBF3D",
            ballSpecularColorNormal: "#FFE4AC",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#FFFFFF, #E9CFF5)',
        },
        {
            losePlatformColor: "#B02A2A",
            losePlatformSpecularColor: "#E75D5D",
            normalPlatformColor: '#FF9955',
            normalPlatformSpecularColor: '#FFB896',
            tubeColor: '#C98FFF',
            tubeSpecularColor: '#E3C4FF',
            ballColorNormal: "#FFBF3D",
            ballSpecularColorNormal: "#FFE4AC",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#FFFDFB, #FFF6C4)',
        },
        {
            losePlatformColor: "#B02A2A",
            losePlatformSpecularColor: "#E75D5D",
            normalPlatformColor: '#6AF851',
            normalPlatformSpecularColor: '#9BFF96',
            tubeColor: '#8FD2FF',
            tubeSpecularColor: '#C4FAFF',
            ballColorNormal: "#FF753D",
            ballSpecularColorNormal: "#FFAFAC",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#E7E7E7, #FFDFF7)',
        },
        {
            losePlatformColor: "#B02A2A",
            losePlatformSpecularColor: "#E75D5D",
            normalPlatformColor: '#519BF8',
            normalPlatformSpecularColor: '#96DCFF',
            tubeColor: '#8FD2FF',
            tubeSpecularColor: '#C4FAFF',
            ballColorNormal: "#FF753D",
            ballSpecularColorNormal: "#FFAFAC",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#E7E7E7, #FFDFF7)',
        },
        {
            losePlatformColor: "#B02A2A",
            losePlatformSpecularColor: "#E75D5D",
            normalPlatformColor: '#FFAC40',
            normalPlatformSpecularColor: '#F8D25C',
            tubeColor: '#F5F2F2',
            tubeSpecularColor: '#F8F8F8',
            ballColorNormal: "#00ABFF",
            ballSpecularColorNormal: "#66E2FF",
            ballColorFire: "#ff0000",
            backgroundGradient: 'linear-gradient(#ED98F3, #A4CAE0)',
        },
    ],
};

const PlatformsDesign = {
    // Difficulty level 0 (0 to 3)
    level_00: [
        {
            count: 28,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            type: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            level: 3,
            randomRotation: 0.6,
        },
        {
            count: 28,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            type: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            level: 3,
            randomRotation: 0.3,

        },
        {
            count: 28,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            type: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            level: 3,
            randomRotation: 0.4,

        },
        {
            count: 28,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            type: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            level: 3,
            randomRotation: 0.2,

        },
    ],
    // Difficulty level 1 (0 to 3)
    level_01:
        [
            {
                count: 23,
                rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
                type: [1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
                level: 0,
                randomRotation: 5.6,
            },
            {
                count: 21,
                rotation: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
                type: [1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
                level: 0,
                randomRotation: 5.1,
            },
            {
                count: 20,
                rotation: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
                type: [1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1],
                level: 0,
                randomRotation: 0,
            },
            {
                count: 24,
                rotation: [0, 1, 2, 3, 4, 5, 6, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
                type: [1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
                level: 0,
                randomRotation: 0.3,
            },
            {
                count: 25,
                rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 19, 20, 21, 22, 23, 24, 25, 26, 27],
                type: [1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1],
                level: 0,
                randomRotation: 12.4,
            },
            {
                count: 25,
                rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 19, 20, 21, 22, 23, 24, 25, 26, 27],
                type: [1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1],
                level: 0,
                randomRotation: 11.4,
            },
            {
                count: 23,
                rotation: [0, 1, 2, 3, 4, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 22, 23, 24, 25, 26, 27, 28],
                type: [1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1],
                level: 0,
                randomRotation: 22.3,
            },
            {
                count: 16,
                rotation: [0, 1, 2, 3, 8, 9, 10, 11, 16, 17, 18, 19, 24, 25, 26, 27],
                type: [1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
                level: 2,
                randomRotation: 8.9,
            }
        ],

    // Difficulty level 2 (0 to 3)
    level_02: [
        {
            count: 24,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
            type: [0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
            level: 1,
            randomRotation: 1.6,
        },
        {
            count: 24,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
            type: [0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
            level: 1,
            randomRotation: 2.3,
        },
        {
            count: 23,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15, 16, 17, 18, 19, 20, 24, 25, 26, 27, 28],
            type: [1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 0, 1, 1, 1, 0, 0],
            level: 1,
            randomRotation: 5.3,
        },
        {
            count: 25,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            type: [1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 0],
            level: 1,
            randomRotation: 22.4,
        },
        {
            count: 25,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            type: [1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1],
            level: 1,
            randomRotation: 12.9,
        },

        {
            count: 23,
            rotation: [0, 1, 2, 3, 4, 5, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 23, 24, 25, 26, 27, 28],
            type: [0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 1, 1, 0],
            level: 1,
            randomRotation: 7.3,
        },
        {
            count: 16,
            rotation: [0, 1, 2, 3, 8, 9, 10, 11, 16, 17, 18, 19, 24, 25, 26, 27],
            type: [1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1],
            level: 2,
            randomRotation: 8.9,
        },
        {
            count: 16,
            rotation: [0, 1, 2, 3, 8, 9, 10, 11, 16, 17, 18, 19, 24, 25, 26, 27],
            type: [1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
            level: 2,
            randomRotation: 3.7,
        }
    ],

    // Difficulty level 3 (0 to 3)
    level_03: [
        {
            count: 21,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 12, 13, 14, 15, 20, 21, 22, 23, 24, 25, 26, 27, 28],
            type: [0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
            level: 2,
            randomRotation: 10.3,
        },
        {
            count: 21,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 12, 13, 14, 15, 20, 21, 22, 23, 24, 25, 26, 27, 28],
            type: [0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
            level: 2,
            randomRotation: 1.5,
        },
        {
            count: 24,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 12, 13, 14, 15, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
            type: [0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            level: 2,
            randomRotation: 2.8,
        }
        ,
        {
            count: 24,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 21, 22, 23, 24, 25, 26, 27, 28],
            type: [0, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1],
            level: 2,
            randomRotation: 1.7,
        },
        {
            count: 24,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 21, 22, 23, 24, 25, 26, 27, 28],
            type: [0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1],
            level: 2,
            randomRotation: 10.3,
        },
        {
            count: 24,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 21, 22, 23, 24, 25, 26, 27, 28],
            type: [0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
            level: 2,
            randomRotation: 7.3,
        }
        ,
        {
            count: 27,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
            type: [0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1],
            level: 2,
            randomRotation: 2.79,
        },
        {
            count: 28,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            type: [0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1],
            level: 2,
            randomRotation: 1.9,
        },
        {
            count: 28,
            rotation: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            type: [0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1],
            level: 2,
            randomRotation: 17.3,
        },
        {
            count: 18,
            rotation: [0, 1, 2, 3, 4, 5, 10, 11, 12, 13, 14, 15, 20, 21, 22, 23, 24, 25],
            type: [0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1],
            level: 2,
            randomRotation: 0,
        },
        {
            count: 18,
            rotation: [0, 1, 2, 3, 4, 5, 10, 11, 12, 13, 14, 15, 20, 21, 22, 23, 24, 25],
            type: [1, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0],
            level: 2,
            randomRotation: 0.8,
        },
        {
            count: 16,
            rotation: [0, 1, 2, 3, 8, 9, 10, 11, 16, 17, 18, 19, 24, 25, 26, 27],
            type: [0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            level: 2,
            randomRotation: 0.3,
        },
        {
            count: 16,
            rotation: [0, 1, 2, 3, 8, 9, 10, 11, 16, 17, 18, 19, 24, 25, 26, 27],
            type: [0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            level: 2,
            randomRotation: 2.5,
        },
        {
            count: 16,
            rotation: [0, 1, 2, 3, 8, 9, 10, 11, 16, 17, 18, 19, 24, 25, 26, 27],
            type: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            level: 2,
            randomRotation: 2.2,
        }
    ],

};

export { GameConfig, PlatformsDesign };